import { yieldMainThread } from "@devowl-wp/react-utils";
import { isCrawler } from "../utils";
/**
 * Is the current request from a spider / crawler?
 */ const preDecisionGatewayIsCrawler = (resultIfBot)=>async (param)=>{
        let { getUserDecision } = param;
        await yieldMainThread();
        if (getUserDecision() !== false || !resultIfBot) {
            return false;
        }
        return isCrawler() ? resultIfBot : false;
    };
export { preDecisionGatewayIsCrawler };
